// extracted by mini-css-extract-plugin
module.exports = {"mob-br":"mob-br__3zD9s","sp-br":"sp-br__2QwAd","non-sp-br":"non-sp-br__3Z2xB"};